
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mailing/[mailingId]/statistics",
      function () {
        return require("private-next-pages/mailing/[mailingId]/statistics/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mailing/[mailingId]/statistics"])
      });
    }
  